import { CircularProgress } from '@mui/material'
import { Input, InputCheck } from 'components'
import { Icons, StaticListData, StaticListProps } from 'interfaces'
import React, { useEffect, useState } from 'react'
import { useInView } from 'react-intersection-observer'
import { configGenaral } from 'utils'

export const StaticList: React.FC<StaticListProps> = ({
	data,
	totalList,
	isLoading,
	resetInput,
	setTotalList,
	fetchNextPage,
	isFetchingNextPage,
	handleChangeDebounce,
	type
}): JSX.Element => {
	const { ref, inView } = useInView()
	const [search, setSearch] = useState('')
	const [listTotalStaticList, setListTotalStaticList] = useState<number[]>(
		totalList.lists
	)
	const [listStaticList, setListStaticList] = useState<StaticListData[]>([])

	useEffect(() => {
		if (inView) {
			if (
				data &&
				data.pages[0] &&
				data.pages[0].pages > data.pageParams.length
			) {
				fetchNextPage()
			}
		}
	}, [inView])

	useEffect(() => {
		if (data?.pages) {
			let aux = [] as StaticListData[]
			data.pages.forEach(page => {
				if (page) {
					aux = [...aux, ...page.items]
				}
				setListStaticList(aux)
			})
		}
	}, [data])

	useEffect(() => {
		setTotalList({
			...totalList,
			lists: listTotalStaticList
		})
	}, [listTotalStaticList])

	return (
		<div>
			<Input
				name="search"
				placeholder="Search Static Lists"
				className="w-full !p-[unset]"
				onChangeCustom={e => {
					setSearch(e.target.value)
					handleChangeDebounce(e)
				}}
				rightIcon={Icons.cancel}
				rightClick={() => {
					resetInput()
					setSearch('')
				}}
				value={search}
				maxLength={configGenaral.maxSearchValue}
				inputClassName="!p-[unset] !py-1 !px-2"
				inputFocus
				borderFull={false}
				search
			/>
			<div className="mt-2">
				{isLoading ? (
					<div className="flex items-center justify-center w-full h-[400px] py-2 px-1 ">
						<CircularProgress disableShrink />
					</div>
				) : (
					<div className="max-h-[370px] overflow-y-auto">
						{listStaticList?.map(item => (
							<InputCheck
								id={item.id}
								key={item.id}
								title={item.name}
								reach={item.members}
								className="mb-4 w-full"
								list={listTotalStaticList}
								setList={setListTotalStaticList}
								name={`${item.name}-${item.id}`}
								type={type}
							/>
						))}
						<div ref={ref}>
							{isFetchingNextPage && <CircularProgress disableShrink />}
						</div>
					</div>
				)}
			</div>
		</div>
	)
}
